var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOval(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.265,
    height: 21.616,
    viewBox: "0 0 22.265 21.616",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "people_love_us_icon7",
    transform: "translate(-1022 -1121.384)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_132",
    "data-name": "\\uD0C0\\uC6D0 132",
    cx: 1.616,
    cy: 1.633,
    rx: 1.616,
    ry: 1.633,
    transform: "translate(1022 1143) rotate(-90)",
    fill: "#7af38a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_133",
    "data-name": "\\uD0C0\\uC6D0 133",
    cx: 1.616,
    cy: 1.633,
    rx: 1.616,
    ry: 1.633,
    transform: "translate(1022 1138.556) rotate(-90)",
    fill: "#7af38a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_134",
    "data-name": "\\uD0C0\\uC6D0 134",
    cx: 1.616,
    cy: 1.633,
    rx: 1.616,
    ry: 1.633,
    transform: "translate(1022 1133.909) rotate(-90)",
    fill: "#7af38a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_135",
    "data-name": "\\uD0C0\\uC6D0 135",
    cx: 1.616,
    cy: 1.633,
    rx: 1.616,
    ry: 1.633,
    transform: "translate(1022 1129.263) rotate(-90)",
    fill: "#7af38a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_142",
    "data-name": "\\uD0C0\\uC6D0 142",
    cx: 1.616,
    cy: 1.633,
    rx: 1.616,
    ry: 1.633,
    transform: "translate(1028.333 1143) rotate(-90)",
    fill: "#7af38a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_143",
    "data-name": "\\uD0C0\\uC6D0 143",
    cx: 1.616,
    cy: 1.633,
    rx: 1.616,
    ry: 1.633,
    transform: "translate(1028.333 1138.556) rotate(-90)",
    fill: "#7af38a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_144",
    "data-name": "\\uD0C0\\uC6D0 144",
    cx: 1.616,
    cy: 1.633,
    rx: 1.616,
    ry: 1.633,
    transform: "translate(1028.333 1133.909) rotate(-90)",
    fill: "#7af38a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_145",
    "data-name": "\\uD0C0\\uC6D0 145",
    cx: 1.616,
    cy: 1.633,
    rx: 1.616,
    ry: 1.633,
    transform: "translate(1028.333 1129.263) rotate(-90)",
    fill: "#7af38a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_146",
    "data-name": "\\uD0C0\\uC6D0 146",
    cx: 1.616,
    cy: 1.633,
    rx: 1.616,
    ry: 1.633,
    transform: "translate(1028.333 1124.616) rotate(-90)",
    fill: "#7af38a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_152",
    "data-name": "\\uD0C0\\uC6D0 152",
    cx: 1.616,
    cy: 1.633,
    rx: 1.616,
    ry: 1.633,
    transform: "translate(1034.666 1143) rotate(-90)",
    fill: "#7af38a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_153",
    "data-name": "\\uD0C0\\uC6D0 153",
    cx: 1.616,
    cy: 1.633,
    rx: 1.616,
    ry: 1.633,
    transform: "translate(1034.666 1138.556) rotate(-90)",
    fill: "#7af38a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_154",
    "data-name": "\\uD0C0\\uC6D0 154",
    cx: 1.616,
    cy: 1.633,
    rx: 1.616,
    ry: 1.633,
    transform: "translate(1034.666 1133.909) rotate(-90)",
    fill: "#7af38a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_162",
    "data-name": "\\uD0C0\\uC6D0 162",
    cx: 1.616,
    cy: 1.633,
    rx: 1.616,
    ry: 1.633,
    transform: "translate(1041 1143) rotate(-90)",
    fill: "#7af38a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_163",
    "data-name": "\\uD0C0\\uC6D0 163",
    cx: 1.616,
    cy: 1.633,
    rx: 1.616,
    ry: 1.633,
    transform: "translate(1041 1138.556) rotate(-90)",
    fill: "#7af38a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_164",
    "data-name": "\\uD0C0\\uC6D0 164",
    cx: 1.616,
    cy: 1.633,
    rx: 1.616,
    ry: 1.633,
    transform: "translate(1041 1133.909) rotate(-90)",
    fill: "#7af38a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_165",
    "data-name": "\\uD0C0\\uC6D0 165",
    cx: 1.616,
    cy: 1.633,
    rx: 1.616,
    ry: 1.633,
    transform: "translate(1041 1129.263) rotate(-90)",
    fill: "#7af38a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOval);
export default __webpack_public_path__ + "static/media/oval.215fe6d07b0b0cacda93330af3e1f202.svg";
export { ForwardRef as ReactComponent };